export * from "./RecordAutomationListPage";
export const RECORDS_AUTOMATION_TITLE = "Record Automation";
export const linkToRecordAutomation = () => {
  return `/app/records/automation`;
};
export const RECORDS_AUTOMATION_BREADCRUMB = {
  title: RECORDS_AUTOMATION_TITLE,
  path: linkToRecordAutomation,
};
